import { PaginationModel, Price } from "@spartacus/core";

export interface UDXOrderQRData {
    orderId?: string,
    orderType?: string,
    qrPdfZipUrl?: string,
    subEntries?: UDXOrderQRDataSubentry[],
    pagination?: PaginationModel,

    // Sort and Filters
    ticketType?: OrderQRKeyValue[],
    qrCodeDownloadedStatus?: OrderQRKeyValue[],
    sortOptions?: OrderQRKeyValue[],

    // USJT-16574:
    pdfDownloadDisabled?: boolean,
    pdfDownloadExpired?: boolean
}

export interface OrderQRKeyValue {
    key?: string,
    value?: string,
    selected?: boolean,
}

export interface UDXOrderQRDataSubentry {
    product?: UDXOrderQRDataProduct,
    quantity?: number,
    ticketCode?: string,
    ticketEntryInfo?: UDXOrderQRDataTicketEntryInfo,
    ticketId?: string,
    ticketPrice?: Price,
    selectedState?: CheckboxState,
    qrDownloadStatus?: boolean,
    mediaCode?:string,
    // USJT-15115 - Start
    status?: string
    // USJT-15115 - End
}

export interface UDXOrderQRDataProduct {
    code?: string,
    name?: string,
    ticketType?: string,
}

export interface UDXOrderQRDataTicketEntryInfo {
    visitationDate?: string,
}

export enum CheckboxState {
    eNoState = 0,
    eUncheckedState = 1 << 0, // Binary 001
    eCheckedState = 1 << 1, // Binary 010
    // Raj: If state is Binary 011 it means that the checkboxes in the list are both checked and unchecked
}